import "./DriverLogEventEdit.css";
import "../../../common/styles/form-style.css";
import {
  Edit,
  ListButton,
  ResourceContextProvider,
  TopToolbar,
} from "react-admin";
import { RouteComponentProps } from "react-router-dom";
import resourceNames from "../../../../common/data/resourceNames";
import { CustomResourceRouteParams } from "../../../../common/types";
import { DriverLogEventEditForm } from "./DriverLogEventEditForm";
import { parseISO } from "date-fns";
import { isString } from "lodash";
import { CreateChangeRequestEvent } from "../../../../common/data/service-proxies";

interface Props extends RouteComponentProps<CustomResourceRouteParams> {
  id?: string;
  onClose: () => void;
  timeZone?: string | null;
}

interface EditActionProps {
  basePath?: string;
  onClose?: () => void;
  data?: CreateChangeRequestEvent;
}

const EditActions = ({ basePath, onClose, data }: EditActionProps) => {
  return (
    <TopToolbar>
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
        onClick={() => {
          if (onClose) onClose();
        }}
      />
    </TopToolbar>
  );
};

export const DriverLogEventEdit = ({ timeZone, ...props }: Props) => {
  return (
    <ResourceContextProvider value={`${resourceNames.HOS_EVENTS}`}>
      <div id="driver-log-event-edit-container">
        <Edit
          title=" "
          basePath={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/${props.match.params.driverId}/${props.match.params.date}`}
          resource={`${resourceNames.HOS_EVENTS}`}
          id={props.id}
          undoable={false}
          onSuccess={() => {
            props.onClose();
          }}
          transform={(record) => {
            return {
              ...record,
              time: isString(record.time)
                ? parseISO(record.time).getTime()
                : record.time,
            };
          }}
          actions={<EditActions onClose={props.onClose} />}
        >
          <DriverLogEventEditForm timeZone={timeZone} />
        </Edit>
      </div>
    </ResourceContextProvider>
  );
};
